import { DepositMode, Percent } from "@silo/types";
import { parsePercentagePoints } from "./string";
import { match } from "ts-pattern";

/**
 * If max LTV is below this threshold, then the asset is considered as disabled collateral.
 *
 * Specified in points: '1' = 1%
 */
const DISABLED_COLLATERAL_THRESHOLD = parsePercentagePoints("1");

export function getIsDisabledCollateral(maxLtv: Percent): boolean {
  return maxLtv <= DISABLED_COLLATERAL_THRESHOLD;
}

/**
 * If a market asset deposit mode is set to `defaultFalse` or `protectedOnly`,
 * then we are encouraging protected deposits in the app. Therefore, throughout
 * the app, we will display yields associated with protected deposits vice
 * collateral deposits.
 *
 * Otherwise, we will display yields associated with collateral/borrowable deposits.
 */
export function getDisplayCollateralYields(depositMode: DepositMode): boolean {
  return match(depositMode)
    .with("defaultTrue", () => true)
    .with("defaultFalse", () => false)
    .with("protectedOnly", () => false)
    .exhaustive();
}
